import React from "react";

const TimeSelectionStep = ({
  selectedDate,
  availableSlots,
  handleSlotSelect,
  setStep,
  formatTime,
}) => {
  return (
    <div className="p-5 flex-1">
      <div className="flex items-center gap-4 mb-6">
        <button
          onClick={() => setStep(1)}
          className="text-primary hover:text-primary/80 font-medium"
        >
          ← Back to dates
        </button>
        <h3 className="text-lg font-semibold">
          Select a Time for {new Date(selectedDate).toLocaleDateString()}
        </h3>
      </div>

      {availableSlots && availableSlots.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {availableSlots.map((slot, index) => (
            <button
              key={index}
              onClick={() => handleSlotSelect(slot)}
              className="p-3 border border-gray-200 rounded-lg hover:border-primary hover:bg-primary/5 transition-colors text-center font-medium text-sm"
            >
              {formatTime(slot.time)}
            </button>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <p className="text-gray-600 mb-2">
            No available time slots for this date.
          </p>
          <p className="text-sm text-gray-500">
            Try selecting a different date or check your Cal.com availability
            settings.
          </p>
        </div>
      )}
    </div>
  );
};

export default TimeSelectionStep;
